const FOUNDER_USER_IDS = new Set([
  'maverick_edvise',
  'niki._yyk',
  'Carson'
]);

const MEMBER_USER_IDS = new Set([
  'CWY1013',
  'HUDT2100',
  'Ewan',
  'Joseph',
  'Jiaxun'
]);

function userIdOf(user) {
  return user?.User_ID || '';
}

export function isFounder(user) {
  return FOUNDER_USER_IDS.has(userIdOf(user));
}

export function isMember(user) {
  return MEMBER_USER_IDS.has(userIdOf(user));
}

/** Founders and members — internal preview / ops access. */
export function isInternalTeam(user) {
  const id = userIdOf(user);
  return FOUNDER_USER_IDS.has(id) || MEMBER_USER_IDS.has(id);
}
